// Native dialog behavior around Ritual's existing Shopify password form.
// Delegation survives password-section re-rendering in the visual editor.
const dialog = document.getElementById('AWSHPasswordDialog');
if (dialog) {
  const open = () => {
    if (!dialog.open) dialog.showModal();
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('.awsh-launch__password')) open();
    if (event.target.closest('.password-dialog__close-button')) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.querySelector('.awsh-launch__password')?.focus({ preventScroll: true });
  });
  if (dialog.hasAttribute('data-password-error')) {
    dialog.close();
    open();
  }
}
